import React from 'react';

import { OpenRowButton, orNotSet } from '../HomeSection';

import { StatusBadge } from './rowBadges';

import { formatDateWithYear } from 'Helpers/dateTimeService';
import { formatFigure } from 'Helpers/formatService';

/**
 * The user's outstanding evaluations, in the same columns the Procurement
 * module's Evaluation Template List shows.
 *
 * The columns are that screen's, deliberately: a user moving between Home and
 * the evaluation list should read the same row twice rather than two different
 * summaries of one record.
 *
 * NO VALUE COLUMN AND NO EXCEPTION MARK. An evaluation template carries no
 * price — it scores bids — and it has no date to be late against, so neither
 * has anything to render.
 *
 * NO TILE OPENS THIS ONE any more, and the table stays: the type is still
 * served by the section endpoint and still reachable from its own module.
 */
export default function EvaluationSectionTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Name')}</th>
                        <th className="tw-w-32">{$t('Status')}</th>
                        <th className="tw-w-24">{$t('Companies')}</th>
                        <th className="tw-w-24">{$t('Scorers')}</th>
                        <th className="tw-w-36">{$t('Created at')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.name })}>
                                    {row.name}
                                </OpenRowButton>
                            </td>
                            <td>
                                <StatusBadge status={row.status} />
                            </td>
                            <td className="inbud-numeric-cell">{formatFigure(row.companies, String)}</td>
                            <td className="inbud-numeric-cell">{formatFigure(row.scorers, String)}</td>
                            <td className="inbud-date-cell">{orNotSet(row.created_at && formatDateWithYear(row.created_at))}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
